import React, {
  ReactElement,
  useEffect,
  useRef,
  useState,
  Fragment,
} from 'react';
import Tooltip from '@mui/material/Tooltip';
import {formatNumber} from '../../../reducer/actions/formatNumber';
import Box from '@mui/material/Box';
import {formatPrice} from '../../../reducer/actions/formatPrice';
import {gridFilteredSortedRowEntriesSelector} from "@mui/x-data-grid-pro";

export const PriceSummaryCell = ({
                                  props,
                                  apiRef,
                                  schema,
                                }: {
  props: any;
  apiRef: any;
  schema: any;
}): ReactElement => {
  const divRef = useRef(null);
  const [tooltip, setTooltip] = useState(false);
  const [totalEUR, setTotalEUR] = useState(0);
  const [totalHUF, setTotalHUF] = useState(0);

  function getDivWidth(divRef: any) {
    if (divRef && divRef.current) {
      const divElement = divRef.current;
      const parentElement = divElement.parentNode;

      const divRect = divElement.getBoundingClientRect();
      const parentRect = parentElement.getBoundingClientRect();

      return {
        element: divRect.width,
        cell: parentRect.width,
      };
    }
    return {
      element: 0,
      cell: 0,
    };
  }

  useEffect(() => {
    setTooltip(false);
    const divWidth: { element: number; cell: number } = getDivWidth(divRef);

    if (divWidth['element'] > divWidth['cell']) {
      setTooltip(true);
    }
  });

  const filteredSortedRowsAndIds = gridFilteredSortedRowEntriesSelector(apiRef);
  const visibleRows = filteredSortedRowsAndIds.map((row:any) => row?.model);

  useEffect(() => {
    let sumEUR = 0;

    const addAmounts = (row: any, field: string) => {
      sumEUR += row[field] || 0;
    };

    visibleRows.forEach((row: any) => {
      if (!row) return;

      const field = props.field;

      if (schema?.viewTable === 'groups') {
        if (row.status_id === 14) {
          return
        } // skip this row
        addAmounts(row, field);

      } else if (schema?.viewTable === 'activity_reservations') {
        const groupSalesPartnerId = row?.group?.sales_partner_id;
        const salesPartnerId = row?.sales_partner?.id;

        if (groupSalesPartnerId !== salesPartnerId) {
          return; // skip this row
        }
        addAmounts(row, field);
      } else {
        addAmounts(row, field);
      }
    });

    setTotalEUR(sumEUR);
  }, [visibleRows]);


  return (
    <Box
      ref={divRef}
      className={`whitespace-nowrap ${
        tooltip ? 'has-tooltip' : 'doesnthave-tooltip'
      }`}
      sx={{
        lineHeight: '14px',
      }}
    >
      {tooltip ? (
        <>
          <Tooltip
            disableInteractive
            title={totalEUR ? formatNumber(totalEUR) : ''}
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '13px',
                },
              },
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -14],
                    },
                  },
                ],
              },
            }}
          >
           <>
             {totalEUR ? (
               <p>
                 {formatPrice(totalEUR)}
               </p>
             ) : (
               <></>
             )}
           </>
          </Tooltip>
        </>
      ) : (
        <>
          <>
            {totalEUR ? (
              <p>
                {formatPrice(totalEUR, true)}
              </p>
            ) : (
              <></>
            )}
          </>
        </>
      )}
    </Box>
  );
};
